export enum LoanTypeForFields {
  // existing
  MULTIFAMILYMIXEDUSE = "MULTIFAMILYMIXEDUSE",
  SFR = "SFR",
  UNIT_24 = "UNIT_24",
  CONDO = "CONDO",
  TOWNHOME = "TOWNHOME",

  // new combined keys
  FIXFLIP_SFR = "FixFlip-Single Family/Detached",
  FIXFLIP_CONDO = "FixFlip-Condo",
  FIXFLIP_TOWNHOME = "FixFlip-Townhome",
  FIXFLIP_UNIT_24 = "FixFlip-Unit 24",
  FIXFLIP_MULTIFAMILYMIXEDUSE = "FixFlip-Multifamily/MixedUse",

  GRUP_SFR = "GrUp-Single Family/Detached",
  GRUP_CONDO = "GrUp-Condo",
  GRUP_TOWNHOME = "GrUp-Townhome",
  GRUP_UNIT_24 = "GrUp-Unit 24",
  GRUP_MULTIFAMILYMIXEDUSE = "GrUp-Multifamily/MixedUse",
}